import { a as e } from "./chunk-4YDW4TIJ.js";
import { n as o, o as r } from "./chunk-56TPPUT7.js";
var f = new o({
  locale: [e, r]
});
export { f as a };